<div>
    <h2>{{ "event_steps.step_location.label" | translate }}</h2>
    <div class="location-selector">
        <location-selector-azure [selectedLocationName]="locationAdress" [defaultLocation]="selectedLatLng"
            (mapClicked)="setLocation($event)" (locationChanged)="setAdress($event)"></location-selector-azure>
    </div>
</div>